import { memo } from 'react';

import { localClearingSystemKey, paymentMethodKey } from '../../AddBeneficiaryPopup.constants';
import Fields from '../Fields/Fields';
import { StepTwoProps } from './StepTwo.types';

const StepTwo = memo<StepTwoProps>((props) => {
    const { fields = [], formValues, setFormValues, fieldsTouched, setFieldsTouched } = props;

    const paymentMethodFieldData = fields.filter((item) => item.path === paymentMethodKey);
    const localClearingSystemFieldData = fields.filter((item) => item.path === localClearingSystemKey);

    return (
        <Fields
            fields={[...paymentMethodFieldData, ...localClearingSystemFieldData]}
            formValues={formValues}
            fieldsTouched={fieldsTouched}
            setFormValues={setFormValues}
            setFieldsTouched={setFieldsTouched}
        />
    );
});

export default StepTwo;
